export const environment = {
  production: true,
  //WMS_Service_URL: 'https://34.95.107.122/WMS_Service/'
  WMS_Service_URL: 'https://warrantreference.airasia.com/WMS_Service/'
};
